export default __webpack_public_path__ + "static/char-s-12-cht-8605b5265e460c69a8f8db2926b98c51.png";